// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.center {
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
}

.container {
  height: 31.25em;
  width: 21.87em;
  margin-top: -60px;
}

.rope {
  height: 13.62em;
  width: 0.15em;
  background-color: #ffffff;
  animation: swing 2s infinite;
}

@keyframes swing {
  50% {
    transform: translateY(-4em);
  }
}

.legs {
  height: 1.12em;
  width: 7.5em;
  background-color: transparent;
  box-shadow: 0 0 0 0.12em #140243, 0 0 0 1.06em #1b1676, 0 0 0 1.18em #140243;
  top: 12.5em;
  border-radius: 3.12em;
}

.boot-l,
.boot-r {
  height: 1.25em;
  width: 2.5em;
  background-color: #e32832;
  position: absolute;
  border: 0.12em solid #140243;
  bottom: 1.12em;
}

.boot-l {
  left: 1em;
}

.boot-r {
  transform: rotateY(180deg);
  left: 3.81em;
}

.boot-l:before,
.boot-r:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 1.12em solid #140243;
  border-left: 1.18em solid transparent;
  bottom: 1.31em;
  left: 1.46em;
}

.boot-l:after,
.boot-r:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 1.12em solid #e32832;
  border-left: 1em solid transparent;
  right: 0;
  top: -0.93em;
}

.costume {
  height: 6.25em;
  width: 5.62em;
  background: linear-gradient(
    to right,
    #1b1676 20%,
    #e32832 20%,
    #e32832 80%,
    #1b1676 80%
  );
  border: 0.12em solid #140243;
  top: 14.68em;
}

.spider {
  height: 1.87em;
  width: 0.93em;
  background-color: #140243;
  border-radius: 45%;
  position: absolute;
  transform: translate(-50%, -50%);
  top: calc(50% + 0.93em);
  left: 50%;
}

.s1,
.s3 {
  height: 7.5em;
  width: 2.5em;
  border-radius: 0 0 1.37em 1.37em;
  border-bottom: 0.12em solid #140243;
  position: absolute;
}

.s2,
.s4 {
  height: 7.5em;
  width: 3.12em;
  border-radius: 0 0 1.56em 1.56em;
  border-bottom: 0.12em solid #140243;
  position: absolute;
}

.s1,
.s2,
.s3,
.s4 {
  left: 50%;
}

.s1 {
  bottom: 1.43em;
}

.s2 {
  bottom: 0.93em;
}

.s3,
.s4 {
  transform: translateX(-50%) rotateX(180deg);
}

.s3 {
  top: 1.43em;
}

.s4 {
  top: 0.93em;
}

.belt {
  height: 0.43em;
  width: 5.87em;
  background-color: #e32832;
  border: 0.12em solid #140243;
  top: -0.12em;
}

.hand-r,
.hand-l {
  height: 8.12em;
  background: linear-gradient(
    #e32832 4.6em,
    #140243 4.6em,
    #140243 4.75em,
    #1b1676 4.75em,
    #1b1676 8.12em
  );
  width: 1.12em;
  border: 0.12em solid #140243;
  border-radius: 1.25em;
  position: absolute;
  transform-origin: bottom;
  bottom: -0.12em;
}

.hand-r {
  right: -0.75em;
  transform: rotate(-22deg);
}

.hand-l {
  left: -0.75em;
  transform: rotate(22deg);
}

.neck {
  height: 0.37em;
  width: 1.25em;
  background-color: #e32832;
  bottom: -0.62em;
  border: 0.12em solid #140243;
}

.mask {
  height: 4.65em;
  width: 4.06em;
  background-color: #e32832;
  border-radius: 50% 50% 50% 50% / 54% 54% 46% 46%;
  border: 0.12em solid #140243;
  top: 6.56em;
}

.eye-l,
.eye-r {
  height: 0.68em;
  width: 1.37em;
  background-color: #ffffff;
  border-radius: 1.37em 1.37em 0 0;
  border: 0.12em solid #140243;
  position: absolute;
  top: 2.1em;
}

.eye-l {
  left: 0.3em;
}

.eye-r {
  right: 0.3em;
}

.cover {
  height: 3.12em;
  width: 0.15em;
  background-color: #ffffff;
  bottom: 8.12em;
}`, "",{"version":3,"sources":["webpack://./src/components/Loader.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,4EAA4E;EAC5E,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,kCAAkC;EAClC,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb;;;;;;GAMC;EACD,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd;;;;;;GAMC;EACD,aAAa;EACb,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,gDAAgD;EAChD,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["\n.center {\n  position: absolute;\n  transform: translateX(-50%);\n  left: 50%;\n}\n\n.container {\n  height: 31.25em;\n  width: 21.87em;\n  margin-top: -60px;\n}\n\n.rope {\n  height: 13.62em;\n  width: 0.15em;\n  background-color: #ffffff;\n  animation: swing 2s infinite;\n}\n\n@keyframes swing {\n  50% {\n    transform: translateY(-4em);\n  }\n}\n\n.legs {\n  height: 1.12em;\n  width: 7.5em;\n  background-color: transparent;\n  box-shadow: 0 0 0 0.12em #140243, 0 0 0 1.06em #1b1676, 0 0 0 1.18em #140243;\n  top: 12.5em;\n  border-radius: 3.12em;\n}\n\n.boot-l,\n.boot-r {\n  height: 1.25em;\n  width: 2.5em;\n  background-color: #e32832;\n  position: absolute;\n  border: 0.12em solid #140243;\n  bottom: 1.12em;\n}\n\n.boot-l {\n  left: 1em;\n}\n\n.boot-r {\n  transform: rotateY(180deg);\n  left: 3.81em;\n}\n\n.boot-l:before,\n.boot-r:before {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-bottom: 1.12em solid #140243;\n  border-left: 1.18em solid transparent;\n  bottom: 1.31em;\n  left: 1.46em;\n}\n\n.boot-l:after,\n.boot-r:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-bottom: 1.12em solid #e32832;\n  border-left: 1em solid transparent;\n  right: 0;\n  top: -0.93em;\n}\n\n.costume {\n  height: 6.25em;\n  width: 5.62em;\n  background: linear-gradient(\n    to right,\n    #1b1676 20%,\n    #e32832 20%,\n    #e32832 80%,\n    #1b1676 80%\n  );\n  border: 0.12em solid #140243;\n  top: 14.68em;\n}\n\n.spider {\n  height: 1.87em;\n  width: 0.93em;\n  background-color: #140243;\n  border-radius: 45%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  top: calc(50% + 0.93em);\n  left: 50%;\n}\n\n.s1,\n.s3 {\n  height: 7.5em;\n  width: 2.5em;\n  border-radius: 0 0 1.37em 1.37em;\n  border-bottom: 0.12em solid #140243;\n  position: absolute;\n}\n\n.s2,\n.s4 {\n  height: 7.5em;\n  width: 3.12em;\n  border-radius: 0 0 1.56em 1.56em;\n  border-bottom: 0.12em solid #140243;\n  position: absolute;\n}\n\n.s1,\n.s2,\n.s3,\n.s4 {\n  left: 50%;\n}\n\n.s1 {\n  bottom: 1.43em;\n}\n\n.s2 {\n  bottom: 0.93em;\n}\n\n.s3,\n.s4 {\n  transform: translateX(-50%) rotateX(180deg);\n}\n\n.s3 {\n  top: 1.43em;\n}\n\n.s4 {\n  top: 0.93em;\n}\n\n.belt {\n  height: 0.43em;\n  width: 5.87em;\n  background-color: #e32832;\n  border: 0.12em solid #140243;\n  top: -0.12em;\n}\n\n.hand-r,\n.hand-l {\n  height: 8.12em;\n  background: linear-gradient(\n    #e32832 4.6em,\n    #140243 4.6em,\n    #140243 4.75em,\n    #1b1676 4.75em,\n    #1b1676 8.12em\n  );\n  width: 1.12em;\n  border: 0.12em solid #140243;\n  border-radius: 1.25em;\n  position: absolute;\n  transform-origin: bottom;\n  bottom: -0.12em;\n}\n\n.hand-r {\n  right: -0.75em;\n  transform: rotate(-22deg);\n}\n\n.hand-l {\n  left: -0.75em;\n  transform: rotate(22deg);\n}\n\n.neck {\n  height: 0.37em;\n  width: 1.25em;\n  background-color: #e32832;\n  bottom: -0.62em;\n  border: 0.12em solid #140243;\n}\n\n.mask {\n  height: 4.65em;\n  width: 4.06em;\n  background-color: #e32832;\n  border-radius: 50% 50% 50% 50% / 54% 54% 46% 46%;\n  border: 0.12em solid #140243;\n  top: 6.56em;\n}\n\n.eye-l,\n.eye-r {\n  height: 0.68em;\n  width: 1.37em;\n  background-color: #ffffff;\n  border-radius: 1.37em 1.37em 0 0;\n  border: 0.12em solid #140243;\n  position: absolute;\n  top: 2.1em;\n}\n\n.eye-l {\n  left: 0.3em;\n}\n\n.eye-r {\n  right: 0.3em;\n}\n\n.cover {\n  height: 3.12em;\n  width: 0.15em;\n  background-color: #ffffff;\n  bottom: 8.12em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
